export enum ScanMode {
  Default = -1,
  FromUserInterface = 0,
  External = 1
}

export default ScanMode;
